/* L&S: Vertrauenszeile auf dem Handy als fließender Endlos-Lauf.
   Verdoppelt die Punkte einmal (Kopien für Screenreader verborgen) und verschiebt die Zeile
   gleichmäßig um genau eine Länge. Antippen hält an. Bei „Bewegung reduzieren“ bleibt die wischbare Zeile. */
(function () {
  const mobile = window.matchMedia('(max-width: 749px)');
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    const list = root.querySelector('.ls-usp__list');
    if (!list || root.dataset.lsMarqueeReady) return;
    root.dataset.lsMarqueeReady = '1';
    const originals = Array.from(list.children);
    let clones = [];

    function enable() {
      if (clones.length === 0) {
        clones = originals.map((li) => {
          const c = li.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('id');
          c.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
          c.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          list.appendChild(c);
          return c;
        });
      }
      root.classList.add('ls-usp--marquee');
      measure();
    }

    function disable() {
      root.classList.remove('ls-usp--marquee');
      clones.forEach((c) => c.remove());
      clones = [];
      list.style.removeProperty('--ls-marquee-shift');
      list.style.removeProperty('--ls-marquee-duration');
    }

    function measure() {
      if (!clones.length) return;
      const shift = clones[0].offsetLeft - originals[0].offsetLeft;
      const speed = parseFloat(root.dataset.speed) || 35;
      list.style.setProperty('--ls-marquee-shift', `${-shift}px`);
      list.style.setProperty('--ls-marquee-duration', `${Math.max(8, shift / speed)}s`);
    }

    function update() {
      if (mobile.matches && !calm.matches) enable();
      else disable();
    }

    // Antippen / Gedrückthalten hält an
    root.addEventListener('pointerdown', () => root.classList.add('is-paused'));
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) =>
      root.addEventListener(ev, () => root.classList.remove('is-paused'))
    );

    mobile.addEventListener('change', update);
    calm.addEventListener('change', update);
    window.addEventListener('resize', () => measure());
    // Schriften und Sterne können die Breite nachträglich ändern
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('load', measure);
    update();
  }

  function init() {
    document.querySelectorAll('[data-ls-marquee]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
